import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=013c443f&scoped=true"
import script from "./vertical.vue?vue&type=script&lang=js"
export * from "./vertical.vue?vue&type=script&lang=js"
import style0 from "./vertical.vue?vue&type=style&index=0&id=013c443f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c443f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013c443f')) {
      api.createRecord('013c443f', component.options)
    } else {
      api.reload('013c443f', component.options)
    }
    module.hot.accept("./vertical.vue?vue&type=template&id=013c443f&scoped=true", function () {
      api.rerender('013c443f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navMenu/vertical.vue"
export default component.exports